import React from "react";
import { Link } from "react-router-dom";

import { Jumbotron } from "./migration";

const defaultSolutions = [
  {
    title: "Order, Inventory, and Dispatch Sync",
    description:
      "For product, ecommerce, or field-ops teams where order updates and stock movement are managed manually across disconnected tools.",
    example:
      "Order placed -> stock reserved and dispatch task created -> shipping status synced back to CRM -> customer notification triggered automatically, cutting re-keying errors and reducing fulfilment delays.",
    image: require("../../editable-stuff/boxes.jpg"),
    accent: "#90be6d",
  },
  {
    title: "Compliance, Intake, and Exception Handling",
    description:
      "For healthcare, finance, labs, or regulated teams where traceability, approvals, and audit trails matter as much as speed.",
    example:
      "Form or scan submitted -> information validated -> approval workflow routed to the right owner -> audit log recorded -> exception alert raised for invalid data, reducing compliance risk and turnaround time.",
    image: require("../../editable-stuff/glass.jpeg"),
    accent: "#f4a261",
  },
  {
    title: "Lead Capture and Appointment Automation",
    description:
      "For service businesses where new enquiries leak because response speed and ownership are inconsistent.",
    example:
      "Web form submitted -> CRM lead scored and assigned -> prospect receives instant SMS/email -> follow-up task sequence created if no reply in 24 hours, lifting booked consultations and reducing lead drop-off.",
    image: require("../../editable-stuff/business.jpg"),
    accent: "#4cc9f0",
  },
];

const fallbackSolutionImage = require("../../editable-stuff/dashboard.jpg");

const ForYou = ({
  heading = "Automation Solutions for Your Business",
  // message = "I work best with businesses where work moves between inboxes, spreadsheets, CRMs, project tools, and people. These are common places where automation creates immediate operational value.",
  message = "From missed leads to delayed deliveries, I build dependable automation that removes manual bottlenecks and keeps work moving across teams and systems.",
  solutions = defaultSolutions,
  cta = "Different industries, same pattern: when work depends on manual data entry, delayed approvals, or missed follow-ups, automation removes bottlenecks and keeps delivery consistent.",
}) => {
  return (
    <Jumbotron
      id="foryou"
      className="m-0 text-white"
      style={{
        backgroundColor: "rgb(15, 18, 24)",
        backgroundImage:
          "radial-gradient(circle at 10% 15%, rgba(76, 201, 240, 0.15), transparent 30%), radial-gradient(circle at 85% 30%, rgba(244, 162, 97, 0.14), transparent 30%)",
      }}
    >
      <div className="container py-5">
        <h2 className="display-4 mb-3 text-center">{heading}</h2>
        <p
          className="lead text-center mb-5 mx-auto"
          style={{ maxWidth: "760px", color: "rgba(255, 255, 255, 0.86)" }}
        >
          {message}
        </p>

        <div className="row g-5 justify-content-center">
          {solutions.map((solution, index) => (
            <div
              className="col-lg-4 col-md-6"
              key={`${solution.title}-${index}`}
            >
              <div
                className="rounded p-4 shadow-sm h-100 d-flex flex-column"
                style={{
                  background:
                    "linear-gradient(145deg, rgba(24, 28, 36, 0.94), rgba(20, 24, 30, 0.9))",
                  border: "1px solid rgba(255, 255, 255, 0.14)",
                  backdropFilter: "blur(4px)",
                  boxShadow: "0 14px 30px rgba(0, 0, 0, 0.28)",
                  color: "#fff",
                }}
              >
                <div
                  style={{
                    border: `1px solid ${solution.accent}`,
                    borderRadius: "14px",
                    overflow: "hidden",
                    marginBottom: "1.15rem",
                  }}
                >
                  <img
                    src={solution.image || fallbackSolutionImage}
                    alt={solution.title}
                    style={{
                      width: "100%",
                      height: "136px",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                </div>
                <h3 className="h5 mb-3">{solution.title}</h3>
                <p
                  className="mb-3 small"
                  style={{
                    color: "rgba(255, 255, 255, 0.88)",
                    lineHeight: 1.55,
                  }}
                >
                  {solution.description}
                </p>
                <div
                  className="mt-auto pt-3"
                  style={{ borderTop: "1px solid rgba(255, 255, 255, 0.1)" }}
                >
                  <p
                    className="text-uppercase mb-2"
                    style={{
                      fontSize: "0.72rem",
                      letterSpacing: "0.12em",
                      color: solution.accent,
                    }}
                  >
                    Example workflow
                  </p>
                  <p
                    className="mb-0 small"
                    style={{
                      color: "rgba(255, 255, 255, 0.72)",
                      lineHeight: 1.6,
                    }}
                  >
                    {solution.example}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <p
          className="lead text-center mt-3 mb-0"
          style={{ color: "rgba(255, 255, 255, 0.82)" }}
        >
          {cta}
        </p>
        {/* <div className="text-center mt-4">
          <Link
            to="/automation"
            className="btn btn-lg"
            style={{
              border: "1px solid rgba(255, 255, 255, 0.58)",
              color: "#fff",
              background:
                "linear-gradient(135deg, rgba(76, 201, 240, 0.22), rgba(255, 255, 255, 0.08))",
              borderRadius: "999px",
              padding: "0.85rem 1.55rem",
              fontWeight: 600,
              letterSpacing: "0.02em",
              boxShadow: "0 12px 28px rgba(0, 0, 0, 0.35)",
            }}
          >
            Learn More About Automation
          </Link>
        </div> */}
      </div>
    </Jumbotron>
  );
};

export default ForYou;
